import { Col, Input, Row, Tooltip, Typography } from "antd";
import SwipeableButton from "./SwipeableButton";
import { StyleSheet } from "../StyleSheet";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Text } = Typography;

interface CardInputFieldsProps {
    cardNumber: string;
    expirationDateCard: string;
    handleCardNumber: (value: string) => void;
    handleExpirationCard: (value: string) => void;
    errorsEmptyFields: {
        creditCard?: string;
        expirationCard?: string;
    };
    isReset: boolean;
    validate: () => void;
}

const CardInputFields: React.FC<CardInputFieldsProps> = ({
    cardNumber,
    expirationDateCard,
    errorsEmptyFields,
    handleCardNumber,
    handleExpirationCard,
    validate,
    isReset,
}) => {
    return (
        <Row gutter={[24, 24]} justify={"center"}>
            <Col xs={12}>
                <Text style={styles.inputTitle}>Número de Tarjeta</Text>
                <Input
                    style={styles.inputText}
                    value={cardNumber}
                    maxLength={19}
                    placeholder='0000 0000 0000 0000'
                    onChange={(event) => handleCardNumber(event.target.value.replace(/[^0-9]/g, ''))}
                />
                {errorsEmptyFields.creditCard && (
                    <Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.creditCard}</Text>
                )}
            </Col>
            <Col xs={12}>
                <Text style={styles.inputTitle}>Vencimiento</Text>
                <Input
                    value={expirationDateCard.replace(/(\d{2})(\d{2})/, "$1/$2")}
                    style={styles.inputText}
                    placeholder='mm/aa'
                    maxLength={5}
                    onChange={(event) => handleExpirationCard(event.target.value)}
                    suffix={
                        <Tooltip title={`Fecha de vencimiento: Fecha ubicada al frente de tu tarjeta, debajo del número de tarjeta.`}>
                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                    }
                />
                {errorsEmptyFields.expirationCard && (
                    <Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.expirationCard}</Text>
                )}
            </Col>
            <Col xs={24} lg={20} xxl={15}>
                <SwipeableButton
                    resetStatus={isReset}
                    onSuccess={validate}
                    color='#0055c2'
                    text='Deslice para confirmar'
                />
            </Col>
        </Row>
    );
};

const styles = StyleSheet.create({
    viewRoot: {
        width: "100%",
        display: 'flex',
        alignItems: 'center',
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 12,
        marginTop: 25
    },
    bodyCard: {
        width: "100%",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 15,
        marginBottom: 15
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputText: {
        marginTop: 10,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    imageStyle: {
        width: 100,
        height: 40,
        paddingLeft: 5
    },
    divRootImg: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginTop: 10,
        alignItems: "center",
    },
    emptyFieldError: {
        fontSize: 11
    },
    textPrincipal: {
        color: "white",
        fontSize: 20,
        fontWeight: 600,
    },
    textRegular: {
        color: "white",
        fontSize: 15,
    },
    cardRoot: {
        backgroundColor: "white",
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20,
    },
    rowCardPrincipal: {
        marginTop: 25,
        display: 'flex',
        justifyContent: 'center',
    },
    divRoot2: {
        borderRadius: 18,
        textAlign: "center",
        backgroundColor: "#002f97",
        marginTop: 15,
        marginBottom: 15
    },
    cardViewRoot: {
        backgroundColor: 'white',
        borderRadius: 15,
        marginBottom: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)"
    },
    textTitle: {
        fontSize: 15,
        color: "#767b81",
        fontWeight: 600,
    },
    icon: {
        fontSize: 15,
        color: "#767b81"
    },
    colCardNumber: {
        width: "100%",
        justifyContent: 'center',
        display: 'flex',
        marginTop: 10
    },
    rowViewPaymentData: {
        marginTop: 10
    },
    inputContainer: {
        width: "80%",
    },
});


export default CardInputFields;